import SentryManager from "../../services/sentry/sentryManager";
import DatadogRUMManager from "../../services/datadog/datadogRumManager";

(() => {
    new SentryManager();
    new DatadogRUMManager();
})();
